import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import withStyles from "@mui/styles/withStyles";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { TextField } from "@mui/material";
import moment from "moment";
import styles from "./DateInput.module.css";

const CustomDateField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "var(--color-theme-10)",
    },
    "& label.Mui-disabled": {
      color: "#888",
    },
    "& .Mui-disabled:hover": {},
    "& label": {
      color: "var(--color-theme-10)",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "var(--color-theme-10)",
    },
    "& .MuiOutlinedInput-multiline": {
      backgroundColor: "var(--color-theme-gray)",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "var(--color-theme-10)",
      },
      "&:hover fieldset": {
        borderColor: "var(--color-theme-10)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "var(--color-theme-10)",
      },
      "& .MuiInputBase-input": {
        color: "var(--color-theme-10)",
      },
      "& .MuiInputBase-input::placeholder": {
        color: "var(--color-theme-10)",
      },
      "& .MuiSelect-icon": {
        color: "var(--color-theme-10)",
      },
    },
  },
})(DatePicker);

function DateInput(props) {
  const { value, onChange, minDate, maxDate, ...otherProps } = props;

  // Convert incoming value to Moment object
  const momentValue = value ? moment(value) : null;

  // Convert minDate and maxDate to Moment objects if provided
  const momentMinDate = minDate
    ? moment.isMoment(minDate)
      ? minDate
      : moment(minDate)
    : undefined;
  const momentMaxDate = maxDate
    ? moment.isMoment(maxDate)
      ? maxDate
      : moment(maxDate)
    : undefined;

  // Handle date change - convert Moment back to ISO string or Date
  const handleChange = (newValue) => {
    if (onChange) {
      // Convert Moment object to ISO string (or Date object if your app uses that)
      const dateValue =
        newValue && newValue.isValid() ? newValue.toISOString() : null;
      onChange(dateValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className={styles.datepicker}>
        <CustomDateField
          {...otherProps}
          value={momentValue}
          onChange={handleChange}
          minDate={momentMinDate}
          maxDate={momentMaxDate}
          format="DD/MM/YYYY"
          enableAccessibleFieldDOMStructure={false}
          slots={{
            openPickerIcon: DateRangeIcon,
            textField: TextField,
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "outlined",
              margin: "normal",
              placeholder: "__/__/____",
              error: props.error,
              InputLabelProps: { shrink: true },
              helperText: "",
            },
            openPickerIcon: {
              className: styles.calendar_icon,
            },
          }}
        />
      </div>
    </LocalizationProvider>
  );
}

export default DateInput;
